import { motion } from 'framer-motion';
import { cn } from '@/lib/cn.js';

/** Wraps a page section with a consistent eyebrow + heading + lead block. */
export function SectionHeader({
  eyebrow,
  title,
  lead,
  align = 'center',
  className,
  children,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={cn(
        'max-w-3xl mx-auto',
        align === 'center' && 'text-center',
        align === 'left' && 'mx-0 text-left',
        className,
      )}
    >
      {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
      {title && (
        <h2 className="h-display text-3xl sm:text-4xl lg:text-5xl text-balance text-ink-900 dark:text-ink-50">
          {title}
        </h2>
      )}
      {lead && (
        <p className="mt-5 text-base lg:text-lg text-ink-600 dark:text-ink-300 text-pretty">
          {lead}
        </p>
      )}
      {children}
    </motion.div>
  );
}

export function Section({ children, className, id }) {
  return (
    <section id={id} className={cn('section', id && 'scroll-mt-28', className)}>
      <div className="container">{children}</div>
    </section>
  );
}
